import { AddressRuleModal } from 'components/schoolDistricts/DistrictsBrowser/AddressRuleModal/AddressRuleModal';
import { AddAddressRuleModalContainerProps } from 'components/schoolDistricts/DistrictsBrowser/AddressRuleModal/AddressRuleModal.types';
import React, { FC } from 'react';

export const AddAddressRuleModalContainer: FC<AddAddressRuleModalContainerProps> = (props) => {
  return <AddressRuleModal {...props} />;
};
